export class API {
  public static STATUS_200 = 200;

  public static STATUS_302 = 302;

  public static STATUS_400 = 400;

  public static API_KEY = process.env.REACT_APP_API_KEY!;

  public static API_CHAT_KEY = process.env.REACT_APP_CHAT_API_KEY!;

  public static API_CHAT_SOURCE_ID = process.env.REACT_APP_CHAT_SOURCE_ID!;

  public static OPENAI_API_TOKEN = process.env.REACT_APP_OPENAI_API_TOKEN!;

  public static ASSISTANT_ID = process.env.REACT_APP_ASSISTANT_ID!;

  public static URL_LOGIN = process.env.REACT_APP_URL_API_LOGIN!;

  public static URL_REST_API = process.env.REACT_APP_REST_API!;

  public static URL_USER = process.env.REACT_APP_URL_USER!;

  public static GOOGLE_MAPS = process.env.REACT_APP_GOOGLE_API_KEY;
}
